/* eslint-disable @typescript-eslint/no-explicit-any */
// Init data store
let dataStore = {};

/* State for shop */
import { state as shopState } from '@/app/store/modules/shop';
if (shopState) {
  dataStore = Object.assign(dataStore, shopState);
}

/* State for layout */
import { state as layoutState } from '@/app/store/modules/layout';
if (layoutState) {
  dataStore = Object.assign(dataStore, layoutState);
}

/* State for page */
import { state as pageState } from '@/app/store/modules/page';
if (pageState) {
  dataStore = Object.assign(dataStore, pageState);
}

/* State for sidebar */
import { state as sidebarState } from '@/app/store/modules/sidebar';
if (sidebarState) {
  dataStore = Object.assign(dataStore, sidebarState);
}

/* State for iframe */
import { state as iframeState } from '@/app/store/modules/iframe';
if (iframeState) {
  dataStore = Object.assign(dataStore, iframeState);
}

export default dataStore;
